import React from 'react';
import PropTypes from 'prop-types';
import RuleForm from './ruleForm';
import InactiveRule from './inactiveRule';

const EventTypeForm = props =>
  props.rules && props.rules.length > 0 ? (
    props.rules.map(rule => (
      <RuleForm
        rule={rule}
        key={rule.eventType + rule.index}
        selectOptions={props.selectOptions}
      />
    ))
  ) : (
    <InactiveRule eventType={props.eventType} />
  );

EventTypeForm.propTypes = {
  eventType: PropTypes.string,
  rules: PropTypes.array,
  selectOptions: PropTypes.object,
};

export default EventTypeForm;
